// extracted by mini-css-extract-plugin
export default {"container":"ProductSKUSection_container__QThWj","header":"ProductSKUSection_header__COeyV"};